import React from 'react';
import { NavigationRouter } from './routes/router';
import '../src/assets/style/webStyle.css'

function App() {
  return (
    <NavigationRouter />
  );
}

export default App;
